import {
  sdoNs,
} from '@modules/constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';

const sdo = {
  namespace: sdoNs.TEACHER_DASHBOARD,
  mutations: {

    /**
     * @return {Object}
     */
    init() {
      return {
        loading: true,
      };
    },
    setNodeInfo(subState, payload) {
      const nodes = {...subState.nodes};
      nodes[payload.id] = payload;
      return {
        ...subState,
        nodes
      };
    },
  },
  decorators: [
  ],
};

storeInstance.addState(sdo);
